
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

function Footer(props) {

  // smooth scrol
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className={props.className}>
        <div className="footer-main-wrapper">
          <div className="footer-vactor">
            <img src={process.env.PUBLIC_URL + "/images/banner/footer-bg.png"} alt="FooterIMG" />
          </div>
          <div className="container">
            <div className="row justify-content-center g-4">
              <div className="col-lg-4">
                <div className="footer-about text-lg-start text-center">
                  <p>
                    CAMP is a run by Fuse Art Space (UK registered charity 1174458) and CAMP Arts & Musiques (Asso. Loi 1901, RNA W093004739)
                  </p>
                  <div className="footer-social-wrap">
                    <h5>Join Us:</h5>
                    <ul className="footer-social-links justify-content-lg-start justify-content-center">
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/camp_fr"
                          target="_blank"
                        >
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.facebook.com/campfr"
                          target="_blank"
                        >
                          <i className="fa-brands fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://whatsapp.com/channel/0029VbAijiPJpe8WT0t0Ij2j"
                          target="_blank"
                        >
                          <i className="fa-brands fa-whatsapp"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.threads.net/@camp_fr"
                          target="_blank"
                        >
                          <i className="fa-brands fa-threads"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.youtube.com/@campfr"
                          target="_blank"
                        >
                          <i className="fa-brands fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4">
                <div className="footer-widget">
                  <h3 className="footer-widget-title">Quick Links</h3>
                  <ul className="footer-links">
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/workshops"
                      >
                        Workshops
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/residencies"
                      >
                        Residencies
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/plus7"
                      >
                        CAMP +7
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/faq"
                      >
                        FAQ
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-4">
                <div className="footer-widget">
                  <h4 className="footer-widget-title">About CAMP</h4>
                  <ul className="footer-links">                      
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/about"
                      >
                        About us
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/contact"
                      >
                        Contact us
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/jobs"
                      >
                        Jobs
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              
            </div>
            <div className="footer-contact-wrapper">
              <h5>Contact Us:</h5>
              <ul className="footer-contact-list">
                <li>
                  <i className="bi bi-envelope-open" />{" "}
                  <a href="mailto:hi@campfr.com">hi@campfr.com</a>
                </li>
                <li>
                  <i className="bi bi-geo-alt" />{" "}
                  CAMP, Aulus les bains, 09140
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-4 col-md-6 order-lg-1 order-3 ">
                <div className="copyright-link text-lg-start text-center">
                  <p>
                    Copyright 2025 CAMP Arts et Musiques
      
                  </p>
                </div>
              </div>
              <div className="col-lg-4  order-lg-2 order-1">
                <div className="footer-logo text-center">
                  <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/`}>
                    <img src={process.env.PUBLIC_URL + "/images/logo-w.png"} alt="FooterIMG" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 order-lg-3 order-2">
                <div className="policy-links">
                  <ul className="policy-list justify-content-lg-end justify-content-center">
                    <li>
                      <Link to={"/terms"}>Terms &amp; Conditions</Link>
                    </li>
                    <li>
                      <Link to={"/privacy"}>Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
